import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class ActivateBankTrialCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(): Promise<any> {
    let args = { 
      start_date: new Date().toISOString().slice(0, 10)
    }
    this.frontend.loading_activate_trial = true;
    await this.dispatcher.dispatch('activate.user.trial.banks', args)
    this.frontend.loading_activate_trial = false;
  }
}